import { Checkbox, Typography } from "@/components/kit";
import { PermissionNew, PermissionTableProps } from "../type";
import { getUniqueColumns } from "../util/getUniqueColumns";
import {
  applyPermissionDependencies,
  deepCloneState,
} from "../util/applyPermissionDependencies";

const PermissionTable = ({
  category,
  subcategoryPermissions,
  isEditable,
  setGroupedPermissions,
}: PermissionTableProps) => {
  const canAccess = true;

  const columns = getUniqueColumns(
    Object.values(subcategoryPermissions).flat(),
  );

  const handleCheckboxChange = (
    { displayName, subCategory, isRoute, name }: PermissionNew,
    checked: boolean,
  ) => {
    if (!isEditable) return;

    setGroupedPermissions((prevState) => {
      const updatedState = deepCloneState(prevState!);
      const permissions = updatedState[category][subCategory];
      const permission = permissions.find(
        (perm) => perm.displayName === displayName,
      );

      if (permission) permission.isEnable = checked;

      if (!isRoute && checked) {
        const route = permissions.find((elm) => elm.displayName === "View");
        if (route) route.isEnable = true;
      }
      if (!checked && displayName === "View") {
        permissions
          .filter((elm) => !elm.isRoute)
          .forEach((elm) => {
            elm.isEnable = false;
          });
      }

      return applyPermissionDependencies(updatedState, name, checked);
    });
  };

  return (
    <div className="border-gray-100 border-[1px] rounded-[12px] p-3">
      <table className="w-full">
        <thead className="border-b-[1px] border-gray-100 text-start">
          <tr className="h-[48px]">
            <th className="text-start w-[200px]">
              <Typography variant="Title5-Bold">{category}</Typography>
            </th>
            {columns.map((col) => (
              <th key={col} className="w-[20%]">
                <Typography variant="BodyPlus1-Regular">{col}</Typography>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Object.entries(subcategoryPermissions).map(
            ([subcategory, perms]) => (
              <tr className="h-[48px]" key={subcategory}>
                <td>
                  <Typography color="text-gray-600" variant="BodyPlus3-Regular">
                    {subcategory}
                  </Typography>
                </td>
                {columns.map((col) => {
                  const permission = perms.find(
                    (perm) => perm.displayName === col,
                  );
                  return (
                    <td className="text-center" key={col}>
                      <div className="flex items-center justify-center  pt-2">
                        <Checkbox
                          id={permission?.id ?? ""}
                          type="checkbox"
                          size="lg"
                          checked={permission?.isEnable || false}
                          disabled={!isEditable || !canAccess}
                          onChange={(e) =>
                            permission &&
                            handleCheckboxChange(permission, e.target.checked)
                          }
                        />
                      </div>
                    </td>
                  );
                })}
              </tr>
            ),
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PermissionTable;
